import { render } from "./LoaderImage.vue?vue&type=template&id=6a15ee0e&scoped=true"
import script from "./LoaderImage.vue?vue&type=script&lang=js"
export * from "./LoaderImage.vue?vue&type=script&lang=js"

import "./LoaderImage.vue?vue&type=style&index=0&id=6a15ee0e&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a15ee0e"]])

export default __exports__